// extracted by mini-css-extract-plugin
module.exports = {"hidden-block-segment":"a10a3f92e9--hidden-block-segment--14_jG"};